(function ($, XTT) {
	'use strict';

	XTT.archiveFilter = {
		_autoload: [
			'initializeFilter'
		],

		initializeFilter: function() {
			var vars = [], hash;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for(var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
	    }
	    $('.xtt-filter').each(function() {
	    	var fieldName = $(this).attr('name');
	    	$(this).val(vars[fieldName]||"");
	    });
		}

	};

})
(jQuery, XTT);